<template>
  <div>
    <data-list class="select_checkbox_column_width_0" :payload="stockObj" :headers="headers" v-model="pagination" :total="total" :loading="stockObj.loading" :pagination="pagination">
    <template slot="expand">
      <v-simple-table dense width="100%" class="dense_table bordered--table">
        <thead>
          <tr>
            <th v-for="(expandHeader, index) in expandHeader" :key="index">{{expandHeader.text}}</th>
          </tr>
        </thead>
        <tbody v-for="(expandList, index) in stockObj.expanded" :key="index">
          <template v-for="(stock, i) in stocksPerLocation">
            <tr :key="`${i}_location`">
              <td>{{ stock.warehousename }}</td>
              <td>{{ stock.locationname }} </td>
              <td>{{ stock.onstock }}</td>
              <td>{{ stock.oncustomerorder }}</td>
              <td>{{ stock.available }}</td>
            </tr>
            <tr style="background: rgb(0,0,0,0.12);" v-if="stock.receivedorderwithbatches && stock.receivedorderwithbatches.length > 0" :key="`${stock.warehouseid}_${stock.locationid}_batch_title`">
              <td colspan="5"><b>{{ $t('message.stock.batchOrWin') }}</b></td>
            </tr>
            <tr style="background: rgba(0,0,0,0.12);" v-for="(batch, j) in stock.receivedorderwithbatches" :key="`${stock.warehouseid}_${stock.locationid}_${j}_batch`">
              <td colspan="2" class="text-center" @click="getWinHistory(batch.batchnumber)">
                <router-link to>{{ batch.batchnumber }} {{ batch.is_defect_batch ? ' (B)' : '' }}</router-link>
                <v-icon v-if="batch.batchnumber" class="ml-2" @click.stop="printWinLabels(expandList.productid, batch.batchnumber)">print</v-icon>
              </td>
              <td>{{ batch.onstock | replaceDotWithComma }}</td>
              <td></td>
              <td></td>
            </tr>
            <!-- <tr style="background: rgb(250 219 229);" v-if="stock.receivedorderwithwin && stock.receivedorderwithwin.length > 0" :key="`${stock.warehouseid}_${stock.locationid}_win_title`">
              <td colspan="5"><b>{{ $t('message.productionOrder.winNumbers') }}</b></td>
            </tr>
            <tr style="background: rgb(250 219 229);" v-for="(winObj, j) in stock.receivedorderwithwin" :key="`${stock.warehouseid}_${stock.locationid}_${j}_win`">
              <td class="text-center" @click="getWinHistory(winObj.win_number)">
                <router-link to>{{ winObj.win_number }}  {{ winObj.is_defect_product ? ' (B)' : '' }}</router-link>
              </td>
              <td></td>
              <td>{{ winObj.onstock | replaceDotWithComma }}</td>
              <td></td>
              <td></td>
            </tr> -->
          </template>
        </tbody>
      </v-simple-table>
      </template>
      <v-container slot="filterForm" grid-list-xl>
        <v-layout row class="">
          <v-flex lg2>
              <v-menu offset-y>
                <template v-slot:activator="{ on }">
                  <v-btn color="primary" :disabled="isTechRole" v-on="on">{{$t('message.common.addNew')}}</v-btn>
                </template>
                <v-list>
                  <v-list-item v-for="(item, index) in menuItems" :key="index" :to="item.to">
                    <v-list-item-title>{{ $t(item.title) }}</v-list-item-title>
                  </v-list-item>
                </v-list>
              </v-menu>
            </v-flex>
            <v-flex lg1>
              <v-btn fab dark small color="success" :loading="loadingForExcel">
                <v-icon dark @click="generateXslx" id="generateexcel">mdi-file-excel</v-icon>
              </v-btn>
            </v-flex>
            <v-flex lg3>
              <v-select hide-details dense outlined clearable class="pt-0" v-model="filterObj.warehouse" @change="getStockListHandler" :items="listOfWarehouse" item-text="name" item-value="id"  :label="$t('message.layout.warehouse')" id="warehouseauto"></v-select>
            </v-flex>
            <v-spacer></v-spacer>
            <v-flex lg3 class="text-right">
              <v-text-field dense hide-details outlined single-line :loading="searchLoading" v-model="filterObj.searchterm" append-icon="search" @keyup.enter="searchLoading = true;getStockListHandler(true)" @click:append="searchLoading = true;getStockListHandler(true)" :label="$t('message.common.search')" class="text-xs-right pt-0" id="searchbtn"></v-text-field>
            </v-flex>
        </v-layout>
      </v-container>
    </data-list>
    <!-- History Data Display -->
    <v-dialog v-model="winHistoryDialog" hide-overlay persistent transition="dialog-bottom-transition">
      <v-card>
        <v-toolbar dark color="primary">
          <h3>{{ $t('message.productionOrder.productionHistory') }}: {{ activeWinNumber || '' }} {{ $t('message.layout.order') }}: {{ activeOrderNumber || '' }}</h3>
          <v-spacer></v-spacer>
          <v-btn icon dark @click="winHistoryDialog = false">
            <v-icon>close</v-icon>
          </v-btn>
        </v-toolbar>
        <v-card-text class="mt-5">
          <v-layout row wrap>
              <table class="v-data-table v-data-table--dense theme--light production_order_history">
                <thead>
                  <tr align="left">
                    <th>{{ $t('message.warehouse.product') }}</th>
                    <th>{{ $t('message.productionOrder.inProduction') }}</th>
                    <th>{{ $t('message.productionOrder.produced') }}</th>
                    <th>{{ $t('message.productionOrder.productionStatus') }}</th>
                    <th>{{ $t('message.order.date') }}</th>
                    <th>{{ $t('message.orders.user') }}</th>
                    <th>{{ $t('message.common.comments') }}</th>
                  </tr>
                </thead>
                <tbody>
                  <template v-for="(record, index) in listOfWINHistories">
                    <tr v-if="record.type === 1" :key="`${index}_1`">
                      <td>
                        {{ `${record.product_number} - ${record.product_name}` }} {{ record.history.WIN_Number ? `( ${record.history.WIN_Number} )` : '' }}
                        {{ record.history.Is_Defect_Product ? '(B)' : '' }}
                      </td>
                      <td>{{ record.history.In_Production | replaceDotWithComma }}</td>
                      <td>{{ record.history.Produced | replaceDotWithComma }}</td>
                      <td>{{ getTranslatedStatus(record.history.Status) }}</td>
                      <td>{{ record.date | dateTimeFormat }}</td>
                      <td>{{ getUserDetails(record.history.User_Id) }}</td>
                      <td>{{ record.history.Comments }}</td>
                    </tr>
                  </template>
                  <tr v-if="listOfWINHistories && listOfWINHistories.length <= 0">
                    <td colspan="7">{{ $t('message.common.no_records') }}</td>
                  </tr>
                </tbody>
              </table>
          </v-layout>
        </v-card-text>
      </v-card>
    </v-dialog>
    <!-- Sales and Production Order Reserved View -->
    <v-dialog v-model="orderDetailsDialog" persistent width="1500">
      <v-card>
        <v-toolbar color="primary">
          <v-spacer></v-spacer>
          <v-btn icon dark @click="orderDetailsDialog = false">
            <v-icon>close</v-icon>
          </v-btn>
        </v-toolbar>
        <v-card-text class="mt-5">
          <v-row>
            <v-col cols="6">
              <h3>{{ $t('message.order.salesOrder') }}:</h3>
                <v-simple-table dense width="100%" class="dense_table bordered--table">
                <thead>
                  <tr align="left">
                    <th>{{ $t('message.warehouse.order') }}</th>
                    <th class="text-right">{{ $t('message.order.qty') }}</th>
                  </tr>
                </thead>
                <tbody>
                  <tr v-for="(record, index) in listOfSalesOrders" :key="index">
                    <td>
                      <router-link :to="`/orders/actions/${record.id}`">{{ record.number }}</router-link>
                    </td>
                    <td class="text-right">{{ record.count | replaceDotWithComma }}</td>
                  </tr>
                  <tr v-if="listOfSalesOrders && listOfSalesOrders.length <= 0">
                    <td colspan="2">{{ $t('message.common.no_records') }}</td>
                  </tr>
                </tbody>
              </v-simple-table>
            </v-col>
            <v-col cols="6">
              <h3>{{ $t('message.stocks.productionOrder') }}:</h3>
                <v-simple-table dense width="100%" class="dense_table bordered--table">
                <thead>
                  <tr align="left">
                    <th>{{ $t('message.warehouse.order') }}</th>
                    <th class="text-right">{{ $t('message.order.qty') }}</th>
                  </tr>
                </thead>
                <tbody>
                  <tr v-for="(record, index) in listOfProductionOrders" :key="index">
                    <td>
                      <router-link :to="`/production_order/order/actions/${record.id}`">{{ record.number }}</router-link>
                    </td>
                    <td class="text-right">{{ record.count | replaceDotWithComma }}</td>
                  </tr>
                  <tr v-if="listOfProductionOrders && listOfProductionOrders.length <= 0">
                    <td colspan="2">{{ $t('message.common.no_records') }}</td>
                  </tr>
                </tbody>
              </v-simple-table>
            </v-col>
          </v-row>
        </v-card-text>
      </v-card>
    </v-dialog>
  </div>
</template>
<script>
import DataList from '../../../components/DataList'
export default {
  components: {
    DataList
  },
  data () {
    return {
      filterObj: {
        searchterm: ''
      },
      isTechRole: JSON.parse(this.$cookie.get(process.env.VUE_APP_USER)).role_id === 3,
      search: '',
      menuItems: [{ title: 'message.whOrder.supplierOrder', to: '/w_h/order/supplierorder/actions' },
        { title: 'message.warehouse.lowStockProposal', to: '/w_h/order/lowstockproposal' },
        { title: 'message.whOrder.adjustmentOrder', to: '/w_h/order/adjustmentorder/actions' },
        { title: 'message.whOrder.returnOrder', to: '/w_h/order/returnorder/actions' },
        { title: 'message.whOrder.transferOrder', to: '/w_h/order/transferorder/actions' }],
      stockObj: {
        expand: true,
        isHeader: true,
        isHideAdd: true,
        hasFilters: true,
        expanded: [],
        selection: [],
        showSelect: false,
        isStock: true,
        hideSelect: true,
        expandHeader: [],
        onExpand: ({ item }) => this.getStockItems(item),
        expandItem: 'stocksperlocation',
        editProp: 'productnumber',
        editURL: (item) => `/w_h/products/actions/${item.productid}`,
        editProp1: 'oncustomerorder',
        editURL1: (item) => this.viewSalesAndProductionOrders(item),
        editProp2: 'onorder',
        editURL2: (item) => `/w_h/order?ids=${JSON.stringify(item.listofwarehouseorders)}`,
        list: [],
        loading: false,
        page: 1
      },
      total: 0,
      loadingForExcel: false,
      listOfWarehouse: [],
      reRender: 0,
      pagination: !this.$formatter.isEmptyObject(this.$store.state.STOCK_INDEX) ? this.$store.state.STOCK_INDEX : { sortBy: ['productnumber'], itemsPerPage: 25, sortDesc: [false], search: '' },
      searchLoading: false,
      listOfWINHistories: [],
      winHistoryDialog: false,
      listOfWorkflowStates: [],
      listOfUsers: [],
      activeOrderNumber: '',
      activeWinNumber: '',
      orderDetailsDialog: false,
      listOfSalesOrders: [],
      listOfProductionOrders: []
    }
  },
  watch: {
    pagination (val) {
      const model = {
        type: 'STOCK_INDEX',
        data: val
      }
      this.$store.commit('rememberOrder', model)
      this.getStockListHandler()
    },
    'filterObj.searchterm' (val) {
      if (!val) {
        this.searchLoading = true
        this.getStockListHandler(true)
      }
    }
  },
  computed: {
    headers () {
      return [{
        text: '', value: 'data-table-expand'
      }, {
        text: this.$t('message.product.number'),
        value: 'productnumber',
        width: '15%'
      }, {
        text: this.$t('message.customer.name'),
        value: 'description',
        width: '25%'
      }, {
        text: this.$t('message.product.salePrice'),
        value: 'saleprice',
        width: '15%'
      }, {
        text: this.$t('message.stock.onStock'),
        value: 'onstock',
        width: '10%'
      }, {
        text: this.$t('message.stock.onOrder'),
        value: 'onorder',
        width: '10%'
      }, {
        text: this.$t('message.whOrder.reserved'),
        value: 'oncustomerorder',
        sortable: false,
        width: '10%'
      }, {
        text: this.$t('message.product.available'),
        value: 'available',
        width: '10%'
      }]
    },
    expandHeader () {
      return [{
        text: this.$t('message.layout.warehouse'),
        value: 'warehousename',
        width: '10%'
      }, {
        text: this.$t('message.stock.location'),
        value: 'locationname',
        width: '10%'
      }, {
        text: this.$t('message.stock.onStock'),
        value: 'onstock',
        width: '10%'
      }, {
        text: this.$t('message.whOrder.reserved'),
        value: 'oncustomerorder',
        width: '10%'
      }, {
        text: this.$t('message.product.available'),
        value: 'available',
        width: '10%'
      }]
    }
  },
  mounted () {
    this.stockObj.loading = true
    this.getSupportListHandler()
    if (!this.$formatter.isEmptyObject(this.$store.state.F_WAREHOUSE)) {
      const warehouseFilters = this.$formatter.cloneVariable(this.$store.state.F_WAREHOUSE)
      const { warehouse, searchterm } = warehouseFilters.filter
      this.filterObj.warehouse = warehouse || 0
      this.filterObj.searchterm = searchterm
    }
    this.filterObj.searchterm = this.pagination.search || ''
  },
  methods: {
    getStockListHandler (isSearch = false) {
      this.stockObj.loading = true
      /* Added to store search in pagination */
      const { page, sortBy, sortDesc, itemsPerPage } = this.$formatter.cloneVariable(this.pagination)
      let pageVal = page || 1
      if (isSearch) pageVal = 1
      const requestModel = { warehouse: this.filterObj.warehouse || 0, sortby: sortBy[0], rowsperpage: itemsPerPage, page: pageVal, descending: sortDesc[0], search: this.filterObj.searchterm || '' }
      const paginationModel = this.$formatter.cloneVariable(this.pagination)
      paginationModel.search = this.filterObj.searchterm
      const model = { type: 'STOCK_INDEX', data: paginationModel }
      this.$store.commit('rememberOrder', model)
      this.$_executeApi('post', 'stocks/filter', requestModel)
        .then((response) => {
          const values = response.data.items
          this.stockObj.expandHeader = []
          this.stockObj.expanded = []
          const transformList = { number: { list: ['saleprice', 'onorder', 'available'], format: 'replaceDotWithComma' } }
          const model = this.$_formatListModel(values, transformList)
          model.forEach((item, index) => {
            item.id = index
            const getAvailable = (item.onstock - item.oncustomerorder)
            item.available = this.$formatter.replaceDotWithComma(getAvailable)
            item.oncustomerorder = this.$formatter.replaceDotWithComma(item.oncustomerorder)
            item.onstock = this.$formatter.replaceDotWithComma(item.onstock)
          })
          this.stockObj.list = model
          this.total = response.data.total
          const data = { type: 'F_WAREHOUSE', data: { filter: this.filterObj } }
          this.$store.commit('rememberFilter', data)
          if (page > 1 && this.total <= itemsPerPage * (page - 1)) {
            this.pagination.page = 1
            this.stockObj.page = 1
          }
        })
        .finally(() => {
          this.stockObj.loading = false
          this.searchLoading = false
        })
    },
    getSupportListHandler () {
      const query = {
        filter: 'isactive eq 1',
        order_by: {
          field: 'name', asc_or_desc: 'asc'
        }
      }
      this.$_executeApi('post', 'warehouses/query', query).then(response => {
        this.listOfWarehouse = response.data
        const item = this.listOfWarehouse.find(x => x.isdefault)
        if (item) {
          this.filterObj.warehouse = item.id
        }
      })
    },
    getStockItems (payload) {
      this.stockObj.loading = true
      this.stocksPerLocation = []
      const filterObj = {
        searchterm: '',
        warehouse: this.filterObj.warehouse || null,
        productid: payload.productid
      }
      this.stocksPerLocation = []
      this.$_executeApi('post', 'stocks/filter', filterObj)
        .then((response) => {
          const values = response.data.items
          const stocksPerLocation = []
          values.forEach((item) => {
            const listOfStocks = this.$formatter.cloneVariable(item.stocksperlocation)
            listOfStocks.map((x) => {
              x.available = this.$formatter.replaceDotWithComma(x.available)
              x.onstock = this.$formatter.replaceDotWithComma(x.onstock)
              x.oncustomerorder = this.$formatter.replaceDotWithComma(x.oncustomerorder)
              x.onorder = this.$formatter.replaceDotWithComma(x.onorder)
            })
            stocksPerLocation.push(...listOfStocks)
          })
          this.stocksPerLocation = [...stocksPerLocation]
        })
        .finally(() => {
          this.stockObj.loading = false
        })
    },
    generateXslx () {
      const model = {}
      this.loadingForExcel = true
      this.$_executeApi('post', 'stocks/generate_xlsx_report', model)
        .then(response => {
          window.open(process.env.VUE_APP_URL + 'file/download?fileName=' + response.data, '_blank')
        })
        .finally(() => {
          this.loadingForExcel = false
        })
    },
    getWinHistory (winNumber) {
      this.stockObj.loading = true
      this.$_executeApi('get', `productionorderitems/get_history_win/${winNumber}`)
        .then(response => {
          const list = response.data
          for (let i = 0; i < list.length; i++) {
            if (!this.activeOrderNumber) this.activeOrderNumber = list[i].order_number
            list[i].history = list[i].history ? JSON.parse(list[i].history) : {}
            list[i].history.Content = list[i].history.Content ? JSON.parse(list[i].history.Content) : {}
          }
          this.listOfWINHistories = list
          // this.activeOrderNumber = winNumber
          this.activeWinNumber = winNumber
          this.winHistoryDialog = true
        })
        .finally(() => {
          this.stockObj.loading = false
        })
    },
    getListOfWorkflowStates () {
      this.$_executeApi('get', 'workflowstates')
        .then(response => {
          this.listOfWorkflowStates = response.data
        })
    },
    getListOfUsers () {
      this.$_getSingleRecordHandler('users')
        .then((response) => {
          const result = response.data
          this.listOfUsers = result
        })
    },
    getTranslatedStatus (status) {
      if (!status) return ''
      const statuses = this.$formatter.cloneVariable(this.listOfWorkflowStates)
      if (statuses && statuses.length > 0) {
        // eslint-disable-next-line eqeqeq
        const getStatus = statuses.find(x => x.id == status)
        return getStatus ? getStatus.name : ''
      }
    },
    getUserDetails (userId) {
      if (!userId) return ''
      const user = this.listOfUsers.find(x => x.id === userId)
      if (user) return user.name
      else return ''
    },
    // print winnumber
    printWinLabels (productId, winNumber, orderId) {
      this.printingLoader = true
      const model = { productid: productId || 0, winnumber: winNumber || '', orderid: orderId }
      this.$_executeApi('post', 'productionorders/generate_label_pdf_per_win', model)
        .then((response) => {
          window.open(`${process.env.VUE_APP_PRINT_PRODUCT_URL}${response.data}`, '_blank')
        })
        .finally(() => {
          this.printingLoader = false
        })
    },
    viewSalesAndProductionOrders (model) {
      this.listOfSalesOrders = model.listofcustomerorders || []
      this.listOfProductionOrders = model.listofproductionorders || []
      this.orderDetailsDialog = true
    }
  }
}
</script>
